import React from 'react';
import Text from './Text';
import {TextProps} from './Text.props';

type RichTextProps = TextProps & {
  text?: string | null;
  boldWeight?: TextProps['weight'];
};

type RichTextSegment = {
  key: string;
  text: string;
  bold: boolean;
};

const splitBold = (value: string): RichTextSegment[] => {
  const parts = value.split('**');
  let offset = 0;
  return parts.map((part, index) => {
    const segment = {
      key: `${index % 2 === 1 ? 'bold' : 'plain'}-${offset}-${part}`,
      text: part,
      bold: index % 2 === 1,
    };
    offset += part.length;
    return segment;
  });
};

const RichText: React.FC<RichTextProps> = ({text, boldWeight = 'bold', ...props}) => {
  if (!text) {
    return null;
  }

  const segments = splitBold(text);

  const {color, align, fontSize, lineHeight, weight} = props;

  return (
    <Text {...props}>
      {segments.map((seg) => (
        <Text
          key={seg.key}
          color={color}
          align={align}
          fontSize={fontSize}
          lineHeight={lineHeight}
          weight={seg.bold ? boldWeight : weight}
        >
          {seg.text}
        </Text>
      ))}
    </Text>
  );
};

export default RichText;
